export default "__VITE_ASSET__29d2fb28__"